import { useState, useEffect } from 'react';
import { supabase } from '../services/supabase';

const ADMIN_EMAILS = ['kolejojo75@gmail.com'];

export function useAdmin() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function checkAdmin() {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (user && user.email) {
          const email = user.email.toLowerCase().trim();
          if (ADMIN_EMAILS.includes(email)) {
            setIsAdmin(true);
          } else {
            setIsAdmin(false);
          }
        } else {
          setIsAdmin(false);
        }
      } catch (error) {
        console.error('Admin check failed', error);
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    }

    checkAdmin();
  }, []);

  return { isAdmin, loading };
}
